import Link from 'next/link';
import styles from './Breadcrumbs.module.css';
import { ArrowRightWithoutCenterIcon } from '@/utils/images/Arrows';

type BreadcrumbItem = {
    label: string;
    href?: string;
};

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
    separator?: React.ReactNode;
    className?: string;
}

export const Breadcrumbs = ({
    items,
    separator = <ArrowRightWithoutCenterIcon />,
    className = '',
}: BreadcrumbsProps) => {
    if (!items || items.length === 0) return null;

    return (
        <nav aria-label="Breadcrumb" className={`${styles.breadcrumbs} ${className}`}>
            <ol className={styles.list}>
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;

                    return (
                        <li key={index} className={styles.item}>
                            {item.href && !isLast ? (
                                <Link href={item.href} className={styles.link}>
                                    {item.label}
                                </Link>
                            ) : (
                                <span className={styles.current}>{item.label}</span>
                            )}

                            {!isLast && (
                                <span className={styles.separator} aria-hidden="true">
                                    {separator}
                                </span>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}